import {
    Directive,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ElementRef,
    NgZone,
    ChangeDetectorRef,
    OnInit
} from '@angular/core';
import { Subscription ,  Observable } from 'rxjs';

import { keycodes } from '../keycodes';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Directive({
  selector: '[onlyIntegerNumber]'
})
export class OnlyIntegerNumberDirective implements OnChanges, OnDestroy, OnInit {
  regex = new RegExp('^[0-9]+$');

  @Input() allowDecimal: boolean = false;

  // In case we need to switch input from number to text according on validation
  // We can turn on/off keydown handler
  @Input() allowAllKeys: boolean = false;

  private subscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (!this.allowAllKeys) {
      this.subscribeKeydown();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.allowAllKeys) {
      if (changes.allowAllKeys.currentValue) {
        this.unsubscribeKeydown();
      } else {
        this.subscribeKeydown();
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribeKeydown();
  }

  private subscribeKeydown(): void {
    this.ngZone.runOutsideAngular(() => {
      this.unsubscribeKeydown();
      this.subscription = fromEvent(this.elementRef.nativeElement, 'keydown')
      .subscribe((event: KeyboardEvent) => {
        if (this.allowAllKeys) { return; }
        // Allow: delete, backspace, tab, esc, enter,
        if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
          // Allow: Ctrl+A
          (event.keyCode === keycodes.LETTER_A && (event.ctrlKey || event.metaKey)) ||
          // Allow: Ctrl+C
          (event.keyCode === keycodes.LETTER_C && (event.ctrlKey || event.metaKey)) ||
          // Allow: Ctrl+V
          (event.keyCode === keycodes.LETTER_V && (event.ctrlKey || event.metaKey)) ||
          // Allow: Ctrl+X
          (event.keyCode === keycodes.LETTER_X && (event.ctrlKey || event.metaKey)) ||
          // Allow: home, end, left, right
          (event.keyCode >= 35 && event.keyCode <= 39) ||
          // Allow: numerical keypad 0-9 numbers
          (event.keyCode >= 96 && event.keyCode <= 105)
        ) {
          // don't do anything
          return;
        }
        // Allow dots
        if (this.allowDecimal && event.key === '.') { return; }
        if (this.regex.test(String.fromCharCode(event.keyCode))) {
          return;
        } else {
          event.preventDefault();
        }
      });
    });
  }

  private unsubscribeKeydown(): void {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
